import cn from 'classnames'
import React, { FC, useRef } from 'react'
import { useTranslation } from 'react-i18next'

import { Button, Input } from '@infologistics/frontend-libraries'

import { IAiAssistantUrlFormProps as IProps } from './types'

import styles from '../AuthNew.module.scss'

const AiAssistantUrlForm: FC<IProps> = (props) => {
  const { handleChange, handleSubmit, values, resetForm, resetText } = props
  const { assistantUrl, isBoldText } = values
  const { t } = useTranslation()

  const refButtons = useRef<HTMLDivElement>(null)

  const classText = isBoldText ? 'fw-700' : ''

  return (
    <form onSubmit={handleSubmit} noValidate className={cn(styles.formUrl, 'mb-2 d-flex')}>
      <Input
        name='assistantUrl'
        onChange={(e) => {
          const { value } = e.target

          handleChange(e)

          if (isBoldText) {
            resetText(value)
          }
        }}
        placeholder={t('auth:aiAssistantUrl.placeholder')}
        value={assistantUrl}
        inputSize='md'
        classes={{ wrapper: cn(styles.base_url, classText), input: 'py-2' }}
        style={{
          height: `${refButtons.current?.clientHeight}px`
        }}
      />
      <div className={cn(styles.formUrl__buttons, 'd-flex')} ref={refButtons}>
        <Button type='submit' theme='primary' size='large' classes='px-5 py-2'>
          <span className='fw-700'>{t('auth:aiAssistantUrl.set')}</span>
        </Button>
        <Button type='button' theme='default' size='large' onClick={resetForm} classes='px-5 py-2'>
          <span className='fw-700'>{t('auth:aiAssistantUrl.reset')}</span>
        </Button>
      </div>
    </form>
  )
}

export default AiAssistantUrlForm
